import React from 'react';
import { useInput } from 'react-admin';
import { Slider, Typography, Box } from '@material-ui/core';

// Plain-language reach control. Stores a numeric cosine threshold (0..1) but
// presents it as a "broader reach <-> more precise" slider so users never see
// the raw score. Higher value = closer match = more precise = less reach.
const marks = [
  { value: 0.25, label: 'Broad' },
  { value: 0.5, label: 'Balanced' },
  { value: 0.75, label: 'Precise' }
];

const ReachSliderInput = ({ label = 'Reach', source, defaultValue = 0.5, ...rest }) => {
  const { input } = useInput({ source, defaultValue, ...rest });
  const value = (input.value === '' || input.value === undefined || input.value === null)
    ? defaultValue
    : Number(input.value);

  return (
    <Box style={{ maxWidth: 360, marginTop: 8, marginBottom: 8 }}>
      <Typography variant="caption" color="textSecondary">{label}</Typography>
      <Slider
        value={value}
        onChange={(event, val) => input.onChange(val)}
        min={0}
        max={1}
        step={0.05}
        marks={marks}
        valueLabelDisplay="auto"
        aria-label="Reach"
      />
      <Box display="flex" justifyContent="space-between">
        <Typography variant="caption" color="textSecondary">Broader reach</Typography>
        <Typography variant="caption" color="textSecondary">More precise</Typography>
      </Box>
    </Box>
  );
};

export default ReachSliderInput;
